import { CognitoUserPool, CognitoUserAttribute, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';

var poolData = {
	UserPoolId: 'us-east-1_Z0Ar0KO88',
	ClientId: '26emd9432d9hkdtfrldvk8bd23',
};
var userPool = new CognitoUserPool(poolData);

let Auth = {

	userPool: userPool,
	onAuthUpdate: null,

	update: (resetCurrent = false) => {

		resetCurrent && Auth.onAuthUpdate && Auth.onAuthUpdate(undefined, undefined, undefined)

		var cognitoUser = userPool.getCurrentUser();
		// console.log('cognitoUser', cognitoUser);

		if (cognitoUser != null) {
			cognitoUser.getSession( (err, session) => {
				if (err) {
					alert(err.message || JSON.stringify(err));
					return;
				}
				// console.log('session token: ', session.getIdToken().getJwtToken());

				// NOTE: getSession must be called to authenticate user before calling getUserAttributes
				cognitoUser.getUserAttributes( (err, attributes) => {
					if (err) {
						// Handle error
					} else {
						console.log(attributes);
						attributes = attributes.reduce((a,v)=> {
							a[v.Name] = v.Value
							return a
						}, {})
						// console.log('attributes', attributes);

						Auth.onAuthUpdate && Auth.onAuthUpdate(cognitoUser, attributes, session.getIdToken().getJwtToken())
					}
				});
			});
		}
		else {
			Auth.onAuthUpdate && Auth.onAuthUpdate(null, null, null)
		}

	}
}

export default Auth
